"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuddenCommand = void 0;
const Command_1 = require("../Command");
const CommandType_1 = require("../lib/CommandType");
/**
 * Delays notes from appearing, starting their movement in the middle of the
 * screen instead of off-screen. Can be placed in the middle of a measure.
 *
 * **Example:**
 *
 * ```
 * #SUDDEN 2 1
 * 1122,
 * ```
 */
class SuddenCommand extends Command_1.Command {
    constructor(appearanceTime, movementWaitTime) {
        super(CommandType_1.CommandType.Sudden);
        this.appearanceTime = appearanceTime;
        this.movementWaitTime = movementWaitTime;
    }
    static parse(args) {
        if (args.length !== 2) {
            return undefined;
        }
        const appearanceTime = parseFloat(args[0]);
        if (isNaN(appearanceTime)) {
            return undefined;
        }
        const movementWaitTime = parseFloat(args[1]);
        if (isNaN(movementWaitTime)) {
            return undefined;
        }
        return new SuddenCommand(appearanceTime, movementWaitTime);
    }
    toString() {
        return `${super.toString()} ${this.appearanceTime} ${this.movementWaitTime}`;
    }
}
exports.SuddenCommand = SuddenCommand;
